var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReachOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 606,
    height: 258,
    viewBox: "0 0 606 258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 242.476,
    height: 122.135,
    fill: "#1a1a1a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(-834 -796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(834 796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M0,135.615V258L606,122.312V0Z",
    fill: "#ffd100"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(1135 840)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M13.97,82.812l-3.055.683-.756,17.986-7.086,1.583,1.77-42.181,12.188-2.723c7.234-1.615,11.168,1.465,10.852,8.991-.256,6.1-3.449,9.422-5.563,10.759,3.018.84,4.36,3.289,4.1,9.517l-.071,1.684a50.383,50.383,0,0,0,.166,8.715l-6.893,1.54c-.5-1.8-.463-5.118-.312-8.753l.064-1.535c.237-5.638-.9-7.272-5.4-6.268Zm.544-6.179c4.3-.962,6.068-3.3,6.246-7.563.153-3.633-1.4-5.372-5.043-4.557l-4.044.9-.5,11.962Zm38.1-3.214L39.838,76.274l-.514,12.249,14.342-3.2-1.151,6.7-20.5,4.58,1.771-42.181L54.2,49.854l-.277,6.609L40.544,59.452l-.43,10.268,12.774-2.855ZM74.856,76.5l-9.209,2.058L63.225,89.62l-7.138,1.594,10.987-44.24,9.25-2.066,7.548,40.1-7.477,1.67L74.856,76.5Zm-7.673-4.779,6.679-1.492c-1.145-7.741-2.086-13.375-2.542-17.264l-.17.039C70.5,57,68.976,63.618,67.183,71.725Zm43.909-4.967c-.267,2.171-1.486,13.215-12.529,15.682-11.316,2.529-12.174-7.718-11.7-19.052.573-13.659,4.691-22.55,13.953-24.619,10.554-2.358,10.971,7.053,10.991,10.391l-7.049,1.574c-.05-1.409.071-6.516-4.321-5.535-4.474,1-5.808,7.046-6.213,16.7-.334,7.954.1,15.252,4.719,14.221,4.246-.948,4.8-6.119,5.046-7.775Zm5.7-30.9,7.138-1.6-.7,16.672,9.592-2.143.7-16.672,7.138-1.594-1.77,42.18-7.138,1.6.794-18.953-9.591,2.142-.8,18.955-7.138,1.594Zm53.532-12.629c8.674-1.938,12.521,3.932,11.906,18.577-.647,15.423-4.885,23.023-14.06,25.072C159.6,68.8,155.7,63.114,156.357,47.5c.639-15.219,5.759-22.437,13.969-24.271ZM163.668,45.8c-.421,10.008.762,15.64,4.939,14.707,4.4-.982,5.885-6.775,6.323-17.208.411-9.8-.71-14.608-5.035-13.642C165.636,30.61,164.062,36.4,163.668,45.8Zm31.864-27.54-1.218,29.021c-.145,3.456.494,7.376,4.876,6.4,4.24-.947,5.293-4.607,5.463-8.66l1.22-29.068,7.138-1.6-1.226,29.186c-.317,7.572-3.365,14.351-12.98,16.5-9.462,2.114-11.977-3.058-11.643-11l1.224-29.183ZM216.2,20.19l.277-6.611,24.147-5.394-.277,6.609-8.5,1.9-1.494,35.57-7.138,1.6L224.7,18.289Z",
    transform: "translate(1.043 2.779)",
    fill: "#1a1a1a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReachOut);
export default __webpack_public_path__ + "static/media/Reach Out.df3fc7885714e1669b1ffbc398b4659a.svg";
export { ForwardRef as ReactComponent };